import Library from "./pages/Library.vue";
import IndexPage from "./IndexPage.vue";

export default [
  {
    path: "/library",
    component: IndexPage,
    redirect: "/library/index",
    name: "library",
    children: [
      {
        path: "list",
        component: Library,
        name: "library.list",
      },
      {
        path: "index/",
        component: Library,
        name: "library.index",
      },
      {
        path: "category/:category",
        component: Library,
        name: "library.category",
      },
    ],
  },
];
